import { locationMenu } from "@/router/location/index.ts";

export const warehouseMenu = [
  {
    path: "/warehouse",
    name: "catalog.parent",
    icon: "home",
    meta: {
      title: "Warehouse",
      parentMenu: true,
      ability: {
        action: "read",
        subject: ["CycleCount", "Outbound", "Preparation", "DeliveryOrder"],
      },
    },
    children: [
      {
        path: "/delivery",
        name: "delivery.parent",
        redirect: "/delivery/printers",
        icon: "truck",
        meta: {
          title: "Delivery",
          parentMenu: true,
          ability: {
            action: "read",
            subject: ["DeliveryPallet", "DeliveryOrder"],
          },
        },
        children: [
          {
            path: "/purchase-order/list",
            name: "purchase-order.list",
            icon: "list",
            component: () => import("@/views/delivery/ShipmentsListPage.vue"),
            meta: {
              printersList: true,
              title: "Shipments List",
              ability: {
                action: "read",
                subject: "DeliveryOrder",
              },
            },
          },
          {
            path: "/purchase-order/create",
            name: "purchase-order.create",
            icon: "shopping-bag",
            component: () => import("@/views/delivery/CreateDelivery.vue"),
            meta: {
              printersList: true,
              title: "Create Delivery",
              pageTitle: "Purchase Order",
              ability: { action: "create", subject: "DeliveryOrder" },
            },
          },
          {
            path: "/purchase-order/pallet/create",
            name: "purchase-order.pallet.create.withoutId",
            icon: "box",
            component: () =>
              import("@/views/delivery/ShipmentPalletCreateWithoutId.vue"),
            meta: {
              title: "Pallet Processing",
              printersList: true,
              ability: { action: "create", subject: "DeliveryPallet" },
            },
          },
          {
            path: "/purchase-order/print",
            name: "purchase-order.label-print",
            icon: "tag",
            component: () => import("@/views/delivery/label-reprinting/LabelReprint.vue"),
            meta: {
              title: "Label Reprinting",
              printersList: true,
              ability: { action: "create", subject: "DeliveryPallet" },
            },
          },
          {
            path: "/purchase-order/case-return",
            name: "purchase-order.case-return",
            icon: "plus",
            component: () => import("@/views/delivery/CaseAdd.vue"),
            meta: {
              title: "Case Add",
              printersList: true,
              ability: { action: "create", subject: "DeliveryPallet" },
            },
          },
          {
            path: "/delivery/printers",
            name: "delivery.printers",
            icon: "printer",
            component: () =>
              import("@/views/delivery/DeliveryPrintersList.vue"),
            meta: {
              title: "Printers",
              printersList: true,
              ability: { action: "read", subject: "Printer" },
            },
          },
        ],
      },
      {
        path: "/packaging",
        name: "prepParent",
        redirect: "/packaging/scan",
        icon: "package",
        meta: {
          title: "Preparation",
          parentMenu: true,
          ability: {
            action: ["create", "read"],
            subject: ["Preparation", "Printers"],
          },
        },
        children: [
          {
            path: "/packaging/retailers/choose",
            name: "packaging.retailers.index",
            icon: "search",
            component: () =>
              import("@/views/preparation/PreparationRetailersPage.vue"),
            meta: {
              title: "Scan",
              printersList: true,
              ability: { action: "create", subject: "Preparation" },
            },
          },
          {
            path: "/packaging/list",
            name: "packaging.list.index",
            icon: "list",
            component: () => import("@/views/preparation/PreparationList.vue"),
            meta: {
              title: "List",
              pageTitle: "Preparation List",
              printersList: true,
              ability: { action: "read", subject: "Preparation" },
            },
          },
          {
            path: "/prep/printers",
            name: "prep.printers",
            icon: "printer",
            component: () =>
              import("@/views/preparation/PreparationPrinters.vue"),
            meta: {
              title: "Printers",
              printersList: true,
              ability: { action: "read", subject: "Printers" },
            },
          },
        ],
      },
      {
        path: "/outbound",
        name: "outbound.parent",
        redirect: "/outbound/shipment/create",
        icon: "box",
        meta: {
          title: "Outbound",
          parentMenu: true,
          ability: {
            action: ["read", "create"],
            subject: ["Outbound", "CaseErase"],
          },
        },
        children: [
          {
            path: "/outbound/shipment",
            name: "outbound.shipment.parent",
            redirect: "/outbound/shipment/create",
            icon: "truck",
            meta: {
              title: "Shipment",
              parentMenu: true,
              ability: { action: ["read", "create"], subject: "Outbound" },
            },
            children: [
              {
                path: "/outbound/shipment/create",
                name: "outbound.shipment.create.index",
                icon: "plus-square",
                component: () =>
                  import(
                    "@/views/outbound/shipment/OutboundShipmentCreate.vue",
                  ),
                meta: {
                  title: "Create",
                  pageTitle: "Outbound Shipment",
                  ability: { action: "create", subject: "Outbound" },
                },
              },
              {
                path: "/outbound/shipment/list",
                name: "outbound.shipment.list.index",
                icon: "list",
                component: () =>
                  import("@/views/outbound/shipment/OutboundShipmentTable.vue"),
                meta: {
                  title: "List",
                  pageTitle: "Outbound Shipment List",
                  ability: { action: "create", subject: "Outbound" },
                },
              },
            ],
          },
          {
            path: "/outbound/case-erase",
            name: "outbound.case-erase.parent.index",
            redirect: "/outbound/case-erase/scan",
            icon: "trash",
            meta: {
              title: "Case Erase",
              parentMenu: true,
              ability: { action: ["read", "create"], subject: "CaseErase" },
            },
            children: [
              {
                path: "/outbound/case-erase/scan",
                name: "outbound.case-erase.scan.index",
                icon: "search",
                component: () =>
                  import("@/views/outbound/erase/OutboundEraseScan.vue"),
                meta: {
                  title: "Scan",
                  ability: { action: "create", subject: "CaseErase" },
                },
              },
              {
                path: "/outbound/case-erase/list",
                name: "outbound.case-erase.list.index",
                icon: "list",
                component: () =>
                  import("@/views/outbound/erase/OutboundEraseTable.vue"),
                meta: {
                  title: "List",
                  pageTitle: "Case Erase List",
                  ability: { action: "read", subject: "CaseErase" },
                },
              },
            ],
          },
        ],
      },
      {
        path: "/inventory/locations",
        name: "inventory.index",
        icon: "clipboard",
        component: () => import("@/views/CycleCount/CycleCount.vue"),
        meta: {
          title: "Cycle Count",
          ability: { action: "read", subject: "CycleCount" },
        },
      },
      ...locationMenu,
    ],
  },
];
